module.exports = __webpack_public_path__ + "static/img/youngStage_new.a06b716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stageImg/youngStage_new.png
// module id = 7lvO
// module chunks = 1